import React from 'react';
import withErrorCatcher from '../../../components/Common/withErrorCatcher.js'
import { push } from 'react-router-redux';
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { withStyles } from '@material-ui/core';
import Avatar from '@material-ui/core/Avatar';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import FolderIcon from '@material-ui/icons/Folder';
import AppContent from '@components/App/appContent';
import CircularProgress from '@material-ui/core/CircularProgress';
import PageContentWrapper from '@components/App/PageComponents/pageContentWrapper';
import Typography from '@material-ui/core/Typography';
import AdminSettingsDrawer from '../../../components/App/Drawers/adminSettingsDrawer';
import AdminSettingsTitle from '../Common/AdminSettingsTitle.js';
import AdminSettingsRow from '../Common/AdminSettingsRow';
import { withTranslation } from 'react-i18next';

const styles = theme => ({
  progress: {
    margin: `0 ${theme.spacing.unit * 2}px`,
    textAlign: 'center',
    align: 'center'
  },
  spinner: {
    textAlign: 'center',
    paddingTop: 16
  },
  paper: {
    padding: 16
  },
  paperStyle: {
    marginBottom: 40
  },
  listStyle: {
    paddingTop: 0,
    paddingBottom: 0
  },
  button: {
    margin: 16
  }
})

export class MappingsPage extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      value: 'a',
      scores: [],
      storageUse: 0,
      docsCount: 0,
      isLoading: true,
      activity: [],
      sources: []
    }

  }

  componentDidMount() {
    this.loadData();
  }

  loadData = () => {
    this.props.sourceService.getSources().then((sources) => {
      this.setState({
        sources,
        isLoading: false
      })
    })
  }

  handleChange = (value) => {
    this.setState({
      value: value,
    });
  };

  onEditClicked = (source) => () => {
    const { goTo, dispatch } = this.props;
    dispatch({ type: 'MAPPING_EDIT_SOURCE', currentSource: source })
    goTo({ pathname: '/admin/sources/edit' })
  }

  render() {
    const { classes, dispatch, templates,t } = this.props;
    const { sources } = this.state;

    const spinner = <div data-intrcm-id="sources_r1kxmcj1" className={classes.spinner}>
      <CircularProgress className={classes.progress} />
    </div>
    let content = spinner;

    if (!this.state.isLoading) {
      content = sources.map((source) => (
          <AdminSettingsRow
            key={source.title}
            onClick={this.onEditClicked(source)}
            primary={source.title}
            secondary={t("Source: ") + source.sourceFilter + "."}
          />
        ))

    }

    return <AppContent >
      <PageContentWrapper drawer={<AdminSettingsDrawer selected={t("sources")} />}>
        <Grid spacing={16}>
          <AdminSettingsTitle text={t('User Impersonalization')} />
          <Paper className={classes.paperStyle}>
            <List>
              {content}
            </List>

            <Button
              className={classes.button}
              variant="raised"
              onClick={() => {
                // Set mapping as currently editted
                this.props.dispatch({
                  type: 'MAPPING_EDIT_MAPPING', currentMapping: {
                    organization: {},
                    previewDisplayTemplate: templates.preview[0],
                    title: '',
                    icon: '',
                    sourceFilter: "",
                    dataTypeFilter: '',
                    displayMappings: [],
                    customFieldsMappings: []
                  }
                })
                // Goto editing page
                this.props.goTo({ pathname: '/admin/sources/create' })
              }}
            >
              {t('New Source')}
                            </Button>
          </Paper>
        </Grid>
      </PageContentWrapper>
    </AppContent>;
  }
}
const mapStateToProps = (state) => ({
  ...state.services,
  templates: state.globalData.templates

})

const mapDispatchToProps = dispatch => {
  return {
    goTo: path => { dispatch(push(path)) },

    dispatch: dispatch
  }
}

export default compose(withStyles(styles),
 withTranslation('admin'),
  connect(
    mapStateToProps,
    mapDispatchToProps
  ))(MappingsPage);